export function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
    }
    return array
}

export function jsonToFormData(json) {
    const formData = new FormData();

    for (const key in json) {
        if (json.hasOwnProperty(key))
        {
            // Verifica se o valor é um arquivo (por exemplo, do tipo Blob ou File)
            if (json[key] instanceof Blob || json[key] instanceof File) {
                formData.append(key, json[key]);
            } 
            // Se for um objeto (mas não File/Blob), converte para string JSON
            else if (typeof json[key] === 'object' && json[key] !== null) {
                // formData.append(key, JSON.stringify(json[key]));
                appendJsonToFormData(formData, key, json[key]);
            }
            // Para outros tipos (string, number, boolean)
            else {
                formData.append(key, json[key]);
            }
        }
    }

    return formData;
}

function appendJsonToFormData(formData, key, value, parentKey = '') {
    const combinedKey = parentKey ? `${parentKey}[${key}]` : key;
    
    if (value && typeof value === 'object' && !(value instanceof File)) {
      // Se for objeto (mas não File), processa recursivamente
      Object.keys(value).forEach(subKey => {
        appendJsonToFormData(formData, subKey, value[subKey], combinedKey)
      })
    } else {
      // Valores primitivos ou File
      formData.append(combinedKey, value)
    }
    
    console.log(`chave: ${key} chave-combinada: ${combinedKey} valor: ${value}`)
}

export function formatarPercentual(valor) {
    if (valor === undefined || valor === null || valor === '') return '00,00%';
    
    const numero = parseFloat(valor);
    
    if (isNaN(numero)) return '00,00%';

    // Formata com 2 casas decimais, troca ponto por vírgula e garante 2 dígitos na parte inteira
    const partes = numero.toFixed(2).split('.');
    const inteiro = partes[0].padStart(2, '0');
    const decimal = partes[1];

    return `${inteiro},${decimal}%`;
}